import React from 'react'

export default function Coursespage() {
  return (
   <div>courses</div>
  )
}
